"use client";

import { Play } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PortfolioPreview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const portfolioItems = [{
    id: 1,
    title: "Commercial Roof Inspection",
    image: "https://pleasing-jennet.10web.cloud/wp-content/uploads/2026/01/DJI_0249-scaled.jpg",
    isVideo: false,
    caption: "Aerial imagery of commercial rooftop equipment "
  }, {
    id: 2,
    title: "Aerial Survey Mapping",
    image: "https://pleasing-jennet.10web.cloud/wp-content/uploads/2026/01/IMG_1609-1-scaled.jpg",
    isVideo: true,
    caption: "Land mapping and survey."
  }, {
    id: 3,
    title: "Night Time Aerial Photography",
    image: "https://pleasing-jennet.10web.cloud/wp-content/uploads/2026/01/Pigs.png",
    isVideo: false,
    caption: "Aerial night operations - Invasive species surveys"
  }, {
    id: 4,
    title: "Thermal Roof Analysis",
    image: "https://pleasing-jennet.10web.cloud/wp-content/uploads/2026/01/20260102_144917601_iOS.png",
    isVideo: true,
    caption: "Moisture Heat loss detection for commercial property"
  }, {
    id: 5,
    title: "Real Estate Aerial Video",
    image: "https://pleasing-jennet.10web.cloud/wp-content/uploads/2026/01/DJI_20251204170401_0005_V-scaled.jpg",
    isVideo: true,
    caption: "Ranch & Farm and High End Property Highlights"
  }, {
    id: 6,
    title: "Real Time Roof Mapping and Take Off",
    image: "https://pleasing-jennet.10web.cloud/wp-content/uploads/2026/01/sample-with-image-Roof-B.bmp",
    isVideo: false,
    caption: "\n"
  }];
  return <section ref={ref} className="relative bg-light-background py-16 px-4 md:px-8 lg:px-16">
      <div className="container mx-auto max-w-7xl">
        <div className={`text-center mb-12 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground-light mb-4">
            Portfolio Preview
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Automated as-built roof documentation utilizing high-fidelity drone photogrammetry.
          </p>
        </div>

        <div className={`transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {portfolioItems.map((item, i) => <CarouselItem key={item.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <Card className="group overflow-hidden border border-border hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1">
                    <CardContent className="p-0">
                      <div className="relative aspect-[4/3] overflow-hidden">
                        <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-out-back)] group-hover:scale-105" />
                        {item.isVideo && <div className="absolute inset-0 flex items-center justify-center bg-primary-dark/40 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)]">
                            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary text-foreground-primary shadow-medium">
                              <Play className="w-6 h-6 ml-1" fill="currentColor" />
                            </div>
                          </div>}
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-primary-dark/90 to-transparent p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                          <p className={`text-sm font-medium ${i === 0 || i === 1 || i === 2 || i === 3 || i === 4 ? 'text-white' : 'text-foreground'}`}>
                            {item.caption}
                          </p>
                        </div>
                      </div>
                      <div className="p-4">
                        <h3 className="text-lg font-display font-semibold text-foreground-light">
                          {item.title}
                        </h3>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hover:bg-primary hover:text-foreground-primary hover:border-primary" />
            <CarouselNext className="hover:bg-primary hover:text-foreground-primary hover:border-primary" />
          </Carousel>
        </div>
      </div>
    </section>;
}